<template>
  <div class="course-schedule">
    <transition name="modal">
      <div class="modal-mask" >
        <div class="modal-wrapper" >
          <div class="modal-container" style="border-radius:10px">
            <div class="header">
              <span></span>
              <ion-label>전체 동화 일정</ion-label>
              <ion-icon name="md-close" size="large" @click="closePopup"></ion-icon>
            </div>
            <div class="progress">
              <table width="100%">
                <tr class="progress-condition">
                  <td>
                    <div class="complete"  >
                      <div class="complete-color"></div>
                      <div class="complete-text"> 완 료</div>
                    </div>
                  </td>
                  <td>
                    <div class="incomplete" >
                      <div class="incomplete-color"></div>
                      <div class="incomplete-text">  미완료</div>
                    </div>
                  </td>
                  <td>
                    <div class="ongoing" >
                      <div class="ongoing-color"></div>
                      <div class="ongoing-text"> 진행중</div>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
            <div class="button-group" style="height:300px; overflow-y:auto">
              <div class="schedule" >
                <div class="weekly-course" v-for= "(item,index) in scheduleList" v-bind:style="computedColor(index)" @click="updateWeekInfo(item)">
                  <div class="weekly" >
                    {{ item.month }}월{{ item.week }}주차 동화
                  </div>
                  <div class="date" >
                    ({{ item.begin_date }} ~ {{ item.finish_date }})
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import * as alert from "../../utils/alert";
import * as ajax from "../../utils/ajax";
import * as utils from '../../utils/utils';

export default {
  name: "CourseSchedule",
  data() {
    return {
      scheduleList: []
    }
  },
  mounted() {
    this.getWeekStudyList();
  },
  methods: {
    getWeekStudyList() {
      ajax.Get(this, "/api/member/schedule/week", function(ref, data) {
        ref.scheduleList = data;
        // console.log(ref.scheduleList)
      });
    },
    setDate(schedule_name, schedule_date) {
      this.$emit("updateDate", month, week);
    },
    closePopup() {
      this.$emit("showDisplay", false);
    },
    computedColor(index) {
      let color;
      if (this.scheduleList[index].all_week == utils.getNumberOfWeek()) { //현재
        if (this.scheduleList[index].total_count === 0 || this.scheduleList[index].total_count - this.scheduleList[index].study_count === 0) {   //완료
          color = "#304FF6"; // 파란색
        } else {  //진행중
          color = "#FF6c00"; //프라이머리(주황색)
        }
      } else if (this.scheduleList[index].all_week < utils.getNumberOfWeek())  { //과거
        if (this.scheduleList[index].total_count === 0 || this.scheduleList[index].total_count - this.scheduleList[index].study_count === 0) {   //완료
          color = "#304FF6"; // 파란색
        } else { //미완료
          color = "#F73E05"; //빨간색
        }
      } else if (this.scheduleList[index].all_week > utils.getNumberOfWeek())  { //미래
        color = "darkgray"; //회색
      }
      // if (item.total_count === 0 || item.total_count - item.study_count === 0) {
      //     color = "#304FF6"; // 파란색
      // } else if (item.total_count > 0 && item.study_count === 0) {
      //     color = "#F73E05"; //빨간색
      // } else if (item.total_count > 0 && item.total_count - item.study_count > 0) {
      //     color = "#FF6c00"; //프라이머리(주황색)
      // } else {
      //     color = "darkgray";
      // }

      return {'background-color': color};
      // return this.scheduleList.all_week[index]
    },
    updateWeekInfo(item) {
      this.$emit("updateWeekInfo", item, false);
    }
  },
  computed: {
  }
}
</script>

<style scoped lang="scss">
div.course-schedule {
  position: absolute;
  top: 55px;
  left: 25px;
  width: calc(100% - 50px);
  font-size: 20px;
  z-index: 99;

  border-radius: 15px 50px 30px 5px;

  div.header {
    padding: 0 5px;
    height: 30px;
    border-radius: 20px 20px 0 0;
    background-color: #fff;

    display: flex;
    justify-content: space-between;
    align-items: center;

    ion-icon {
      margin-left:10px;
    }

    ion-label {
      margin-left: 40px;
      font-weight: 500;
      font-size: 18px;
      color: black;
    }
  }
  div.progress {
    background-color: white;
    display: flex;
    justify-content: space-around;
    font-size: 13px;
    font-weight: 400;
    padding: 10px;
    width: 100%;

    tr.progress-condition {
      text-align:center;

      div.complete {
        display: flex;
        justify-content: center;

        div.complete-color {
          background:#304FF6;
          width:20px;
        }
        div.complete-text {
          margin-left:4px
        }
      }

      div.incomplete {
        display: flex;
        justify-content: center;

        div.incomplete-color {
          background:#F73E05;
          width:20px;
        }
        div.incomplete-text {
          margin-left:4px
        }
      }

      div.ongoing {
        display: flex;
        justify-content: center;

        div.ongoing-color {
          background:#ff6c00;
          width:20px;
        }
        div.ongoing-text {
          margin-left:4px
        }
      }

    }


    // div.complete {
    //     background-color: red;
    // }
  }
  div.button-group {
    border-radius: 0px 0px 10px 10px;

    div.weekly-course {
      display: flex;
      height: 35px;
      // background-color: #ff6b00;
      justify-content: center;
      margin-bottom: 6px;
      font-weight: 500;
      box-shadow: 0 3px darkgrey;

      div.weekly {
        color:#fff;
        font-size:15px;
        display: flex;
        align-items: center;
        padding-right: 10px;
      }

      div.date {
        font-size:12px;
        display: flex;
        align-items: center;
        padding-top: 3px;
      }
    }
  }
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 15px 0px 0px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
